export namespace Constants {
  export const PATIENT_ACTIONS_SESSION_STORAGE_KEY = "patient-actions";
  export const LOGIN_REDIRECT_PATH_STORAGE_KEY = "redirectPath";
  export const RECALL_APPT_LINK_DOB_STORAGE_KEY = "PATIENT_DOB";
  export const PATIENT_DETAILS_CONFETTI = "patient-details-confetti";
  export const BOOKING_SUCCESS_CONFETTI = "booking-success-confetti";
  export const SHORT_CODE_ID_STORAGE_KEY = "short-code-id";

  class Route {
    private _segments: Array<string>;

    constructor(private _path: string) {
      this._segments = this._path.split("/");
    }

    public get last(): string {
      return this._segments[this._segments.length - 1];
    }

    public get full(): string {
      return this._path;
    }

    public get path(): string {
      return `/${this._path}`;
    }
  }

  export namespace ROUTES {
    export const ACCOUNT_BALANCE = new Route("account/balance");
    export const ACCOUNT_PAYMENT_SUCCESS = new Route("account/payment-success");
    export const ACCOUNT_INVOICES = new Route("account/invoices");
    export const LOGIN_RE_ENTER_PASSWORD = new Route("login/re-enter-password");
  }
}
